import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../Firebase/firebaseconfig";

export const registrarAuditoria = async ({
  accion,
  entidadTipo,
  entidadId,
  antes = null,
  despues = null,
  detalle = "",
}) => {
  try {
    const actor = getAuth().currentUser;

    await addDoc(collection(db, "auditoria"), {
      accion,
      entidadTipo,
      entidadId,
      detalle,
      antes,
      despues,
      actorUid: actor?.uid || "",
      actorEmail: actor?.email || "",
      fecha: serverTimestamp(),
    });
  } catch (err) {
    console.error("No se pudo registrar auditoria:", err);
  }
};
